import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DefaultValueAccessor, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ControlContainerComponent, InheritedControlValueAccessorComponent } from '@knorr-bremse-portals/ngx-components/internal/controls';
import { LabelComponent } from '@knorr-bremse-portals/ngx-components/components/label';

@Component({
  selector: 'kb-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, FormsModule, ControlContainerComponent, LabelComponent ],
})
export class InputComponent extends InheritedControlValueAccessorComponent<string> {

  protected controlId = `kb-input-${this.uniqueId}`;

  @Input() public on?: 'background';

  @Input() public placeholder?: string;
  @Input({ required: true }) public type!: 'text' | 'email' | 'password' | 'number' | 'search' | 'url' | 'time';

  @Input() public standalone = false;
  @Input() public showRequired = true;
  @Input() public ariaLabel?: string;

  // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete, https://html.spec.whatwg.org/multipage/forms.html#autofill
  @Input() public autocomplete?: 'on' | 'off' |
    'name' | 'honorific-prefix' | 'given-name' | 'additional-name' | 'family-name' | 'honorific-suffix' | 'nickname' |
    'email' |
    'username'| 'new-password' | 'current-password' | 'one-time-code' |
    'organization-title' | 'organization' |
    'street-address' | 'address-line1' | 'address-line2' | 'address-line3' | 'address-level1' | 'address-level2' | 'address-level3' | 'address-level4' | 'country' | 'country-name' | 'postal-code' |
    'cc-given-name' | 'cc-additional-name' | 'cc-family-name' | 'cc-number' | 'cc-exp' | 'cc-exp-month' | 'cc-exp-year' | 'cc-csc' | 'cc-type' |
    'transaction-currency' | 'transaction-amount' |
    'language' |
    'bday' | 'bday-day' | 'bday-month' | 'bday-year' |
    'sex' |
    'impp' |
    'url' |
    'photo'
  ;

  @Input() public step?: number | 'any';
  @Input() public min?: string; // Format: hh:mm:ss
  @Input() public max?: string; // Format: hh:mm:ss

  @ViewChild(DefaultValueAccessor) protected valueAccessor!: DefaultValueAccessor;

  @ViewChild('input') public inputElement!: ElementRef<HTMLInputElement>;

}
